resourcePaths = '{"rootPath":"","assetsPath":""}';function BooleanGroup() {
    this.extends = [_Input];
    this.priority = 1100;
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.fieldsetNode = null;
    this.groupElements = [];
    this.placeholderNode = null;
    this.containerDiv = null;

    // Set this to Boolean if you want your BooleanGroup to only return
    // true/false instead of an array. Max 1 checkbox or 1 radio button set with values "true" / "false"
    this.type = "";
    this.placeholder = "";

    this.init = function() {
        // Add class
        $(this.node).addClass("mogo-ui-boolean-group");
        this.containerDiv = this.node;

        if (this.type === "boolean" &&
          ($(this.node).find('[type="checkbox"]').length > 1 || $(this.node).find('[type="radio"]').length > 2 )) {
            console.throw('BooleanGroup with type "Boolean" only supports 1 checkbox or 2 radio buttons.');
        }

        // convert passed in type to lowercase
        this.type = this.type.toLowerCase();

        // Wrap in fieldset
        this.fieldsetNode = $("<fieldset></fieldset>").insertBefore(this.node);
        var childNodes = this.node.childNodes;
        for (var i = childNodes.length - 1; i >= 0; i--) {
            $(childNodes[i]).detach().prependTo(this.fieldsetNode);
        }
        $(this.fieldsetNode).appendTo(this.node);

        // Check for legend/placeholder
        if ($("legend", this.node).length > 0) {
            this.placeholderNode = $("legend", this.node)[0];

        } else if ($(this.node).attr("placeholder") != null) {
            this.placeholder = $(this.node).attr("placeholder");
            this.placeholderNode = $("<legend></legend>");

            $(this.placeholderNode).html(this.placeholder);
            $(this.placeholderNode).prependTo(this.fieldsetNode);

        } else if (this.placeholder != "") {
            this.placeholderNode = $("<legend></legend>");

            $(this.placeholderNode).html(this.placeholder);
            $(this.placeholderNode).prependTo(this.fieldsetNode);
        }

        this._super();

        $(this.node).css("display", "block");
    };

    this.initAllReady = function() {
        // Find elements
        this.groupElements = $("[data-mogo-ui='Radio'], [data-mogo-ui='Checkbox']", this.node);
        for (var i = 0; i < this.groupElements.length; i++) {
            $($(this.groupElements)[i]).mogo().groupInstance = this;
        }
    };

    this.val = function(value) {
        if (value == null) {
            // create boolean array
            var resultArr = [];
            for (var i = 0; i < this.groupElements.length; i++) {
                if (this.type === "boolean" && this.groupElements[i].getAttribute("type") == "checkbox") {
                    // if elm is a checkbox in a boolean type booleanGroup return "true" / "false"
                    resultArr.push(String(this.groupElements[i].checked));
                } else {
                    if (this.groupElements[i].checked) {
                        resultArr.push(this.groupElements[i].value);
                    }
                }
            }

            // if the array is empty return null
            if (resultArr.length == 0) {
                return null;

            } else {
                // if type boolean return a boolean instead of an array
                if (this.type === "boolean") return resultArr[0] == "true" ? true : false;
                //  console.log('resultArr', resultArr);
                // return boolean array
                return resultArr;
            }
        } else {
            // if working with booleans convert value to string to match element value
            if (this.type === "boolean") value = String(value);
            for (var i = 0; i < this.groupElements.length; i++) {
                // get element value
                var elmValue = this.groupElements[i].value;

                // if elm is a checkbox and group is type boolean set its state else treat as normal boolean group
                if (this.type === "boolean" && this.groupElements[i].getAttribute("type") == "checkbox") {
                  if (value == "true") $(this.groupElements[i]).mogo().setChecked(true);
                  else $(this.groupElements[i]).mogo().setChecked(false);

                } else {
                  // set element to check/unchecked
                  if (elmValue == value) $(this.groupElements[i]).mogo().setChecked(true);
                  else $(this.groupElements[i]).mogo().setChecked(false);
                }
            }
        }
    };
}
